import { createAction } from '@ngrx/store';
import { ResourceGroupInternalModel } from '@spog-ui/shared/models/resource-groups';
import { IndieSensorInternalModel } from '@spog-ui/shared/models/indie-sensors';

export const loadFormDataSuccessAction = createAction(
  '[Add Equipment API] Load Form Data Success',
  (
    resourceGroups: ResourceGroupInternalModel[],
    indieSensors: IndieSensorInternalModel[],
  ) => ({
    resourceGroups,
    indieSensors,
  }),
);

export const loadFormDataFailureAction = createAction(
  '[Add Equipment API] Load Form Data Failure',
  (error: string) => ({ error }),
);

export const createEquipmentSuccess = createAction(
  '[Add Equipment API] Create Equipment Success',
);

export const createEquipmentFailure = createAction(
  '[Add Equipment API] Create Equipment Failure',
  (error: string) => ({ error }),
);
